<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
        :showBtn="false"
        :title="`POS Collection Report (${reportType === 'user' ? 'User Wise' : 'Date Wise'})`"
      />
    </div>

    <div class="px-2">
      <DateQuerySetter
        btnTitle="Go"
        @onClickGo="onClickGo"
      >

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">User</label>
          <v-select placeholder="User" :options="contactList" label="name"
              :reduce="(name) => name.id" v-model="userId" />
        </div>
      </DateQuerySetter>
    </div>

    <ul class="nav nav-tabs px-1 pt-1" role="tablist">
      <li class="nav-item">
        <a :class="['nav-link', { active: reportType === 'date' }]" style="cursor: pointer" @click="reportType = 'date'">Date Wise</a>
      </li>
      <li class="nav-item">
        <a :class="['nav-link', { active: reportType === 'user' }]" style="cursor: pointer" @click="reportType = 'user'">User Wise</a>
      </li>
    </ul>

    <div class="col-12">
      <div class="d-flex justify-content-end px-2 mb-1">
        <button
            @click="onClickToPrint"
            class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
        >
          Print
        </button>
        <button
            @click="exportTable"
            class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
        >
          Export
        </button>
      </div>
      <div class="px-2">
        <ListTable :tableItems="activeReportList" :totals="totals" :mopHeads="mopHeads" :reportType="reportType"/>
      </div>
    </div>
  </div>
  <Loader v-if="loading"/>
</template>

<script setup>
import DateQuerySetter from '@/components/atom/DateQuerySetter';
import { ref, inject, onMounted, computed  } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import TitleButton from '@/components/atom/TitleButton';
import ListTable from '@/components/atom/super-shop/pos-collection-report/ListTable.vue';
import handleInventory from "@/services/modules/inventory";
import handleImportTracker from "@/services/modules/procurement/importTracker";
import Loader from "@/components/atom/LoaderComponent.vue";
import handleCompany from "@/services/modules/company";
import pdfPrinter from "@/services/utils/pdf/posCollectionPdf";

const route = useRoute()
const dateWiseList = ref([]);
const userWiseList = ref([]);
const reportType = ref('date');

const activeReportList = computed(() => {
  return reportType.value === 'user' ? userWiseList.value : dateWiseList.value;
})

const userId = ref(null);
const contactList = ref([]);
const loading = ref(false);
const totals = ref({});
const mopHeads = ref([]);
const companyInfo = ref({});

const { fetchPosCollectionReport } = handleInventory();
const { fetchContacts } = handleImportTracker();
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = pdfPrinter();

const showSuccess = inject('showSuccess');
const showError = inject('showError');

const companyId = computed(() => {
  return route.params.companyId
})
const startDate = computed(() => {
  return route.query.start
})
const endDate = computed(() => {
  return route.query.end
})

const token = computed(() => localStorage.getItem('token'));

const getQuery = () => {
  let query = '?company_id=' + companyId.value;
  if(startDate.value) query += '&start_date='+startDate.value;
  if(endDate.value) query += '&end_date='+endDate.value;
  if(userId.value) query += '&user_id='+ userId.value;

  return query
}

const onClickGo = async() => {
  loading.value = true;
  totals.value = {}
  dateWiseList.value = [];
  userWiseList.value = [];
  mopHeads.value = [];
  const query = getQuery();
  try{
    const res = await fetchPosCollectionReport(query);
    if(! res.status) {
      return;
    }
    let data = res.data;
    dateWiseList.value = data.date_wise;
    userWiseList.value = data.user_wise;
    totals.value = data.totals;
    mopHeads.value = data.mop_heads;
  } catch(err){
    console.log(err)
  } finally {
    loading.value = false;
  }
};

async function onClickToPrint() {
  let query = getQuery();
  totals.value = {}
  dateWiseList.value = [];
  userWiseList.value = [];
  mopHeads.value = [];

  await fetchPosCollectionReport(query).then((res) => {
    if(! res.status) return;
    let data = res.data;
    dateWiseList.value = data.date_wise;
    userWiseList.value = data.user_wise;
    totals.value = data.totals;
    mopHeads.value = data.mop_heads;
  }).then(() => {
    const tableItems = reportType.value === 'user' ? userWiseList.value : dateWiseList.value;
    exportToPDF(companyInfo.value, tableItems, totals.value, mopHeads.value, startDate.value, endDate.value, reportType.value)
  }).catch((err) => {
    console.log(err);
  });
}

const exportTable = () => {
  let query = getQuery();
  let url = `${process.env.VUE_APP_BASE_URL}/export/reports/pos-collection-report${query}&_token=${token.value}&is_export=1&report_type=${reportType.value}`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
}

onMounted(async () => {
  loading.value = true

  const companyQuery = `?company_id=${companyId.value}&search_type=all`

  await Promise.all([
    fetchContacts(companyQuery).then(({status, data}) => {
      if (status) contactList.value = data
    }),
    fetchCompanyInfo(companyId.value).then(({status, data}) => {
      if (status) companyInfo.value = data
    }),
  ]).then(() => {
    loading.value = false;
  }).catch((err) => {
    loading.value = false
  });
})
</script>
